var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.debugEnabled
    ? _c(
        "div",
        { class: _vm.css },
        [
          _vm._l(_vm.buttons, function (item, key) {
            return _c(
              "div",
              {
                key: key,
                staticClass: "hero-homepage__debug-button",
                on: {
                  click: function ($event) {
                    return _vm.click(item)
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(item.label) + "\n    ")]
            )
          }),
          _vm._v(" "),
          _vm.debug
            ? _c("div", {
                staticClass: "hero-homepage__debug-content",
                domProps: { innerHTML: _vm._s(_vm.content) },
              })
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }